/** Helper function to convert RGB color to hex format **/
export function rgbToHex(rgb: string): string {
  const hex = rgb
    .replace(/[^\d,]/g, '')
    .split(',')
    .map((value) => Number(value).toString(16).padStart(2, '0'))
    .join('');

  return `#${hex}`;
}
